import CustomElementComponent_DefaultComponent from '../components/CustomElementComponent/viewer/skinComps/Default/Default.skin';
import CustomElementComponent_DefaultController from '../components/CustomElementComponent/viewer/CustomElementComponent.controller';


const CustomElementComponent_Default = {
  component: CustomElementComponent_DefaultComponent,
  controller: CustomElementComponent_DefaultController
};


export const components = {
  ['CustomElementComponent_Default']: CustomElementComponent_Default
};

